import { stripTrailingSlash } from "@/shared/bootstrap/bootRedirect.ts";
import type { Cvpartner } from "@/shared/bootstrap/cvpartner.ts";
import { invariant } from "@/shared/util/invariant.ts";

export function getCvPartner(): Cvpartner {
  const cvpartner = (window as unknown as { cvpartner?: Cvpartner }).cvpartner;
  invariant(cvpartner, "CVPartner is not initialized");
  return cvpartner;
}

export function skipFetchingUser(pathname = window.location.pathname) {
  const path = stripTrailingSlash(pathname);

  if (path === "/login") return true;
  if (path === "/login/admin") return true;
  if (path === "/login/as") return true;
  if (path === "/login/otp") return true;
  if (path === "/login/signed_out") return true;

  return false;
}
